// extracted by mini-css-extract-plugin
export var messageSideLeft = "_k1-1";
export var messageSideRight = "_k1-2";
export var orderLookupBubbleContainer = "_k1-0";
export var submitButton = "_k1-3";